module.exports = __webpack_public_path__ + "img/证书1.f9452faa.jpg";